import {Application} from 'pixi.js';
import {StaticData} from '../data/StaticData';
import {ContextMenuRemoveController} from './silent/ContextMenuRemoveController';
import {DynamicData} from '../data/DynamicData';

export class PixiApplicationController
{
    public static app: Application;

    /**
     * Создать PIXI-Контейнер
     */
    static create(): void {
        const isMac = StaticData.platform.indexOf('MAC') >= 0;
        PixiApplicationController.app = new Application({
            width: DynamicData.sceneSizes.width,
            height: DynamicData.sceneSizes.height,
            antialias: !isMac,
            backgroundAlpha: 0,
            // backgroundColor: 0x35654d,
            resolution: window.devicePixelRatio || 1
        });

        PixiApplicationController.app.view.style.display = 'block';
        PixiApplicationController.app.view.style.width = DynamicData.sceneSizes.width + 'px';
        PixiApplicationController.app.view.style.height = DynamicData.sceneSizes.height + 'px';
        PixiApplicationController.app.stage.interactive = true;
        PixiApplicationController.app.stage.hitArea = PixiApplicationController.app.renderer.screen;

        ContextMenuRemoveController.start(PixiApplicationController.app);
    }

    /**
     * Перерисовка PIXI-Контейнера при изменении размеров окна
     */
    static resize(): void {
        PixiApplicationController.app.renderer.resize(DynamicData.sceneSizes.width, DynamicData.sceneSizes.height);
        PixiApplicationController.app.view.style.width = DynamicData.sceneSizes.width + 'px';
        PixiApplicationController.app.view.style.height = DynamicData.sceneSizes.height + 'px';
        PixiApplicationController.app.stage.hitArea = PixiApplicationController.app.renderer.screen;
    }

    /**
     * Изменение указателя мыши
     * @param cursorMode идентификатор указателя в соответствие с документацией JS
     */
    static changeCursorMode(cursorMode: 'auto' | 'default' | 'none' | 'context-menu' | 'help' | 'pointer' | 'progress' | 'wait' | 'cell' | 'crosshair' | 'text' | 'vertical-text' | 'alias' | 'copy' | 'move' | 'no-drop' | 'not-allowed' | 'e-resize' | 'n-resize' | 'ne-resize' | 'nw-resize' | 's-resize' | 'se-resize' | 'sw-resize' | 'w-resize' | 'ns-resize' | 'ew-resize' | 'nesw-resize' | 'col-resize' | 'nwse-resize' | 'row-resize' | 'all-scroll' | 'zoom-in' | 'zoom-out' | 'grab' | 'grabbing') {
        PixiApplicationController.app.renderer.plugins.interaction.cursorStyles.default = cursorMode;
        PixiApplicationController.app.renderer.plugins.interaction.setCursorMode(cursorMode);
    }
}
